module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.memberInfo.nickname)), (_vm.realName) ? _c('span', [_vm._v("(" + _vm._s(_vm.realName) + ")")]) : _vm._e(), _vm._v("的訂單列表")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('order-table')], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7eb62eb2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Member/MemberOrderTable.vue
// module id = 2498
// module chunks = 1